import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  CHANGE_INPUT_ARTICLE: "change_input_article",
  CHANGE_OBJECT_ARTICLE: "change_object_article",
  DOCUMENTS_LOADED: "documents_loaded",
  RELOAD_DOCUMENTS: "reload_documents",
  OPEN_MODAL_LOAD_DOCUMENTS: "open_modal_load_documents",
  OPEN_MODAL_LOAD_MEASURES: "open_modal_load_measures",
  CHANGE_INPUT_DOCUMENT_BY_ID: "change_input_document_by_id",
  CHANGE_INPUT_OBSERVATION: "change_input_observation",
  OBSERVATIONS_LOADED: "observations_loaded",
  RELOAD_OBSERTATIONS: "reload_observations",
  MEASURES_LOADED: "measures_loaded",
  MEASURES_CHECK_LOADED: "measures_check_loaded",
  CHECK_UNCHECK_MEASURE: "check_uncheck_measure",
  MOVEMENTS_LOADED: "movements_loaded",
  USERS_LOADED: "users_loaded",
  WAREHOUSES_LOADED: "warehouses_loaded",
  CHANGE_INPUT_FILTER_MOVEMENTS: "change_input_filter_movements",
  RELOAD_MOVEMENTS_BY_FILTER: "reload_movements_by_filter",
  SET_INVENTORY_ITEMS: "set_inventory_items",
  SET_MEASURE_ARTICLE: "set_measure_article",
  MEASURES_CHECK_NOT_LOADED: "measures_check_not_loaded",
  SET_INVENTORY_ITEMS_INITIAL: "set_inventory_items_initial",
  SET_INITIAL_STATE_ARTICLE: "set_initial_state_article",
  SET_SELECTED_PDF: "set_selected_pdf",
};
export const INITIAL_STATE = {
  article: {
    id: null,
    name: "",
    code: "",
    measure_name_main: "",
    has_lote: false,
    type: "",
    has_date_made: false,
    has_date_expired: false,
    description: "",
    created_at: new Date(),
    open_data_sheet_modal: false,
    open_measure_modal: false,
    selectedPdf: null,
    status: LOADED,
    to_edit: true,
    lookedItems:[],
    inventory: {
      detail_item: {
        selected: {
          item_id: null,
          warehouse_id: null,
          measure_name: ""
        },
        items: []
      },
      items: [],
      filter: {
        warehouses_id: [],
        measures_id: [],
      },
      view_datail: true,
    },
    documents: {
      status: STATUS_NOT_LOADED,
      elements: [],
    },
    measures: {
      satus: STATUS_NOT_LOADED,
      elements: [],
    },

    observation: {
      text: "",
      status: STATUS_NOT_LOADED,
      observations: [],
    },
    items: {
      status: STATUS_NOT_LOADED,
      elements: [],
    },
    headquarters: {
      status: STATUS_NOT_LOADED,
      elements: [],
    },
    warehouses: {
      status: STATUS_NOT_LOADED,
      elements: [],
    },
    users: {
      status: STATUS_NOT_LOADED,
      elements: [],
    },
    itemsCheckMeasure: {
      status: STATUS_NOT_LOADED,
      elements: [],
    },
    movements: {
      filter: {
        init_date: null,
        end_date: null,
        warehouses_id: [],
        headquarters_id: [],
        responsables_id: [],
        type_code: null,
        types_detail: [],
        limit: 20,
        page: 1,
      },
      rows: 0,
      status: STATUS_NOT_LOADED,
      elements: [],
      selectedPdf: null,
    },
  },
};
export const articleReducer = (state, action) => {
  const payload = action.payload;
  const {
    CHANGE_INPUT_ARTICLE,
    CHANGE_OBJECT_ARTICLE,
    DOCUMENTS_LOADED,
    RELOAD_DOCUMENTS,
    CHANGE_INPUT_DOCUMENT_BY_ID,
    CHANGE_INPUT_OBSERVATION,
    OBSERVATIONS_LOADED,
    RELOAD_OBSERTATIONS,
    MEASURES_LOADED,
    MEASURES_CHECK_LOADED,
    MEASURES_CHECK_NOT_LOADED,
    CHECK_UNCHECK_MEASURE,
    MOVEMENTS_LOADED,
    USERS_LOADED,
    WAREHOUSES_LOADED,
    CHANGE_INPUT_FILTER_MOVEMENTS,
    RELOAD_MOVEMENTS_BY_FILTER,
    SET_INVENTORY_ITEMS,
    SET_MEASURE_ARTICLE,
    SET_INVENTORY_ITEMS_INITIAL,
    SET_INITIAL_STATE_ARTICLE,
    SET_SELECTED_PDF
  } = types;
  switch (action.type) {
    case CHANGE_INPUT_ARTICLE:
      return {
        ...state,
        article: {
          ...state.article,
          [payload.name]: payload.value,
        },
      };
      case SET_MEASURE_ARTICLE:
        return {
          ...state,
          article: {
            ...state.article,
            measure_name_main: payload,
          },
        }
        ;
    case SET_INVENTORY_ITEMS:
      return {
        ...state,
        article: {
          ...state.article,
          inventory: payload,
        },
      };
    case CHANGE_OBJECT_ARTICLE:
      return {
        ...state,
        article: payload,
      };

    case DOCUMENTS_LOADED:
      return {
        ...state,
        article: {
          ...state.article,
          documents: {
            ...state.article.documents,
            status: LOADED,
            elements: payload,
          },
        },
      };
    case MEASURES_LOADED:
      return {
        ...state,
        article: {
          ...state.article,
          measures: {
            ...state.article.measures,
            status: LOADED,
            elements: payload,
          },
        },
      };
    case RELOAD_DOCUMENTS:
      return {
        ...state,
        article: {
          ...state.article,
          documents: {
            ...state.article.documents,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case CHANGE_INPUT_DOCUMENT_BY_ID:
      let doc = state.article.documents.elements.filter(
        (d) => d.id === payload.id
      )[0];
      doc[payload.name] = payload.value;
      return {
        ...state,
        article: {
          ...state.article,
          documents: {
            ...state.article.documents,
            elements: [
              ...state.article.documents.elements.filter(
                (d) => d.id !== payload.id
              ),
              doc,
            ],
          },
        },
      };
    case CHANGE_INPUT_OBSERVATION:
      return {
        ...state,
        article: {
          ...state.article,
          observation: {
            ...state.article.observation,
            [payload.name]: payload.value,
          },
        },
      };
    case OBSERVATIONS_LOADED:
      return {
        ...state,
        article: {
          ...state.article,
          observation: {
            ...state.article.observation,
            observations: payload,
            status: LOADED,
          },
        },
      };
    case MOVEMENTS_LOADED:
      return {
        ...state,
        article: {
          ...state.article,
          movements: {
            ...state.article.movements,
            elements: payload.elements,
            rows: payload.rows,
            status: LOADED,
          },
        },
      };
    case USERS_LOADED:
      return {
        ...state,
        article: {
          ...state.article,
          users: {
            ...state.article.users,
            elements: payload,
            status: LOADED,
          },
        },
      };
    case WAREHOUSES_LOADED:
      return {
        ...state,
        article: {
          ...state.article,
          warehouses: {
            ...state.article.warehouses,
            elements: payload,
            status: LOADED,
          },
        },
      };
    case MEASURES_CHECK_LOADED:
      return {
        ...state,
        article: {
          ...state.article,
          itemsCheckMeasure: {
            ...state.article.itemsCheckMeasure,
            elements: payload,
            status: LOADED,
          },
        },
      };
      case MEASURES_CHECK_NOT_LOADED:
        return {
          ...state,
          article: {
            ...state.article,
            itemsCheckMeasure: {
              ...state.article.itemsCheckMeasure,
              status: STATUS_NOT_LOADED,
            },
          },
        };
    case CHECK_UNCHECK_MEASURE:
      return {
        ...state,
        article: {
          ...state.article,
          itemsCheckMeasure: {
            ...state.article.itemsCheckMeasure,
            elements: state.article.itemsCheckMeasure.elements.includes(payload)
              ? state.article.itemsCheckMeasure.elements.filter(
                (m) => m !== payload
              )
              : [...state.article.itemsCheckMeasure.elements, payload],
          },
        },
      };
    case RELOAD_OBSERTATIONS:
      return {
        ...state,
        article: {
          ...state.article,
          observation: {
            ...state.article.observation,
            status: STATUS_NOT_LOADED,
          },
        },
      };
    case CHANGE_INPUT_FILTER_MOVEMENTS:
      return {
        ...state,
        article: {
          ...state.article,
          movements: {
            ...state.article.movements,
            filter: {
              ...state.article.movements.filter,
              [payload.name]: payload.value,
            },
          },
        },
      };
    case RELOAD_MOVEMENTS_BY_FILTER:
      return {
        ...state,
        article: {
          ...state.article,
          movements: {
            ...state.article.movements,
            status: STATUS_NOT_LOADED,
            filter: {
              ...state.article.movements.filter,
              page: 1,
            },
          },
        },
      };

      case SET_INVENTORY_ITEMS_INITIAL:
        return {
          ...state,
          article: {
            ...state.article,
            inventory: {
              ...state.article.inventory,
              detail_item: {
              ...state.article.inventory.detail_item,
                items: INITIAL_STATE.article.inventory.detail_item.items,

              },
            },
          },
        };

        case SET_INITIAL_STATE_ARTICLE:
          return INITIAL_STATE;
    case SET_SELECTED_PDF:
      return {
        ...state,
        article: {
          ...state.article,
          selectedPdf: payload,
        },
      };
    default:
      return state;
  }
};
